import React, { useState } from 'react';
import { IconButton, Menu, ListItemIcon } from '@mui/material';
import { MoreVertRounded, FileUploadRounded, DeleteRounded } from '@mui/icons-material';
import { IMiRecurso } from '../../../types/miRecurso';
import { StyledMenuItem, DangerMenuItem } from './styles';

interface ThreeDotMenuProps {
  recurso: IMiRecurso;
  onSubirNuevaVersion: (recurso: IMiRecurso) => void;
  onBorrar: (recurso: IMiRecurso) => void;
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({ recurso, onSubirNuevaVersion, onBorrar }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action: (recurso: IMiRecurso) => void) => {
    action(recurso);
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <MoreVertRounded fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClick={(e) => e.stopPropagation()}
      >
        <StyledMenuItem onClick={() => handleAction(onSubirNuevaVersion)}>
          <ListItemIcon>
            <FileUploadRounded fontSize="small" />
          </ListItemIcon>
          Subir nueva versión
        </StyledMenuItem>

        <DangerMenuItem onClick={() => handleAction(onBorrar)}>
          <ListItemIcon>
            <DeleteRounded fontSize="small" />
          </ListItemIcon>
          Borrar
        </DangerMenuItem>
      </Menu>
    </>
  );
};

export default ThreeDotMenu;
